import { parse } from "graphql";
export const getAddDialogueQuery = payload => {
  var _payload$feedback;
  const includeSA = payload.referenceDialogueId ? true : false;
  const includeAIFields = payload.isAIDraftSelected === true;
  const includeFeedback = (_payload$feedback = payload.feedback) === null || _payload$feedback === void 0 ? void 0 : _payload$feedback.trim();
  const saFields = {
    types: ", $referenceDialogueId: String",
    params: ", referenceDialogueId: $referenceDialogueId"
  };
  const aiFields = {
    types: [", $isAIDraftSelected: Boolean", ", $lastCustomerDialogueId: String", includeFeedback ? ", $feedback: String" : ""].join(""),
    params: [", isAIDraftSelected: $isAIDraftSelected", ", lastCustomerDialogueId: $lastCustomerDialogueId", includeFeedback ? ", feedback: $feedback" : ""].join("")
  };
  return parse(`mutation addDialogue($messageId: String!, $body: String!${includeSA ? saFields.types : ""}${includeAIFields ? aiFields.types : ""}) {
        addDialogue(messageId: $messageId, body: $body${includeSA ? saFields.params : ""}${includeAIFields ? aiFields.params : ""}) {
            custConfirmationState
            dialogues {
                dialogueId
                origin
                type
                created
                author
                body
                userId
                contentModerated {
                    action
                    reason
                }                
            }
        }
    }
`);
};
export const CLAIM_MESSAGE = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "claimMessage"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "messageId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "claimMessage"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "messageId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "messageId"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "claimed"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "userId"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "claimedAt"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 173,
    "source": {
      "body": "\n    mutation claimMessage($messageId: String!) {\n        claimMessage(messageId: $messageId) {\n            claimed\n            userId\n            claimedAt\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export const UNCLAIM_MESSAGE = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "unclaimMessage"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "messageId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "unclaimMessage"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "messageId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "messageId"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "claimed"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "userId"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 155,
    "source": {
      "body": "\n    mutation unclaimMessage($messageId: String!) {\n        unclaimMessage(messageId: $messageId) {\n            claimed\n            userId\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export const CLAIM_TIMEOUT_INC = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "responding"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "messageId"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "typing"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Boolean"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "responding"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "messageId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "messageId"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "typing"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "typing"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "claimTimeoutInc"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "totalIncrement"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 199,
    "source": {
      "body": "\n    mutation responding($messageId: String!, $typing: Boolean!) {\n        responding(messageId: $messageId, typing: $typing) {\n            claimTimeoutInc\n            totalIncrement\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export const getAddAttachmentMutation = (payload, apiName) => {
  const includeBody = payload.body ? true : false;
  const includeOrigin = payload.origin ? true : false;
  const bodyFields = {
    types: ", $body: String",
    params: ", body: $body"
  };
  const originFields = {
    types: ", $origin: String!",
    params: ", origin: $origin"
  };
  return parse(`mutation ${apiName}($messageId: String!, $contentType: String!, $fileName: String!, $fileSize: Int!, ${includeOrigin ? originFields.types : ""}${includeBody ? bodyFields.types : ""}) {
        ${apiName}(messageId: $messageId, contentType: $contentType, fileName: $fileName, fileSize: $fileSize, ${includeOrigin ? originFields.params : ""}${includeBody ? bodyFields.params : ""}) {
            url        
        }        
    }
`);
};